

<div class="progress-sec">
    <mat-slider min="1" max="100" step="1" value="50"></mat-slider>
</div>